import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { QcMessageAppConfigurationState } from '../reducers/qc-message-app-configuration.reducer';
import * as selectors from '../selectors/qc-message-app-configuration.selectors';
@Injectable()
export class QcMessageAppConfigurationFacadeService extends FacadeService {
  constructor(public override store: Store<QcMessageAppConfigurationState>) {
    super(store);
  }

  // OBSERVABLES

  name$ = this.storeSelect(selectors.getName);
  notificationEmail$ = this.storeSelect(selectors.getNotificationEmail);
  isActive$ = this.storeSelect(selectors.getStatus);
  username$ = this.storeSelect(selectors.getUsername);
  password$ = this.storeSelect(selectors.getPassword);
  lookBackDays$ = this.storeSelect(selectors.getLookBackDays);
  showUpdateBtn$ = this.storeSelect(selectors.getShowUpdateBtn);
  showCancelBtn$ = this.storeSelect(selectors.getShowCancelBtn);
  disableNameValue$ = this.storeSelect(selectors.getDisableNameValue);
  qcEndpointConfHelpTextStatus$ = this.storeSelect(selectors.getQcEndpointConfHelpTextStatus);
  credentialsConfHelpTextStatus$ = this.storeSelect(selectors.getCredentialsConfigurationHelpTextStatus);
  campaignReportingHelpTextStatus$ = this.storeSelect(selectors.getCampaignReportingHelpTextStatus);
  qcMessageAppDataAreValid$ = this.storeSelect(selectors.getQcMessageAppDataAreValid);
  showNameErrorMsg$ = this.storeSelect(selectors.getShowNameErrorMsg);
  showNotificationEmailErrorMsg$ = this.storeSelect(selectors.getShowNotificationEmailErrorMsg);
  showUserNameErrorMsg$ = this.storeSelect(selectors.getShowUsernameErrorMsg);
  showBaseUrlErrorMsg$ = this.storeSelect(selectors.getShowUsernameErrorMsg);
  showPasswordErrorMsg$ = this.storeSelect(selectors.getShowPasswordErrorMsg);
  showLookBackDaysErrorMsg$ = this.storeSelect(selectors.getShowLookBackDaysErrorMsg);
  showNotificatioEmailErrorMsg$ = this.storeSelect(selectors.getShowNotificationEmailErrorMessage);
  showLookBackDaysValidationErrorMsg$ = this.storeSelect(selectors.getShowLookBackDaysValidationErrorMessage);

  // OBSERVABLE'S VALUES

  get name() {
    return this.storeSnapshot(this.name$);
  }

  get notificationEmailQc() {
    return this.storeSnapshot(this.notificationEmail$);
  }

  get status() {
    return this.storeSnapshot(this.isActive$);
  }

  get username() {
    return this.storeSnapshot(this.username$);
  }

  get password() {
    return this.storeSnapshot(this.password$);
  }

  get lookBackDays() {
    return this.storeSnapshot(this.lookBackDays$);
  }

  get showUpdateBtn() {
    return this.storeSnapshot(this.showUpdateBtn$);
  }

  get qcMessageAppDataAreValid() {
    return this.storeSnapshot(this.qcMessageAppDataAreValid$);
  }

  getQcMessageAppBody() {
    const qcBodyDTO = {
      integrationCode: this.name,
      deleted: this.status,
      integrationConfig: {
        integrationSystem: 'QC_MESSAGE_APP',
        integrationDisplayName: this.name,
        executionNotificationReceiver: this.notificationEmailQc,
        daysLookBack: this.lookBackDays,
      },
      endpointConfiguration: {
        code: this.name,
        endpointConfig: {
          type: 'HTTP',
        },
        credentialConfig: {
          type: 'HTTP_BASIC',
          username: this.username,
          password: this.password,
        },
      },
    };

    return qcBodyDTO;
  }
}
